module.exports = __webpack_public_path__ + "assets/187165068a26f9530b6c3deee66ddec3.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/BgmIntro.mp3
 ** module id = 342
 ** module chunks = 0
 **/